module.exports = __webpack_public_path__ + "img/megacard.ed3bbe95.png";